import Image from '@alltrails/core/components/Image';
import Typography from '@alltrails/core/components/Typography';
import { FormattedMessage } from 'react-intl';
import Button from '@alltrails/denali/components/Button';
import useIsMobileSizedScreen from '@alltrails/denali/hooks/useIsMobileSizedScreen';
import missionMobileImg from '../../assets/images/mission/mission-mobile.avif';
import missionImg from '../../assets/images/mission/mission.avif';
import styles from './styles/styles.module.scss';

// Desktop: https://www.figma.com/file/XrlDM2ZdWXmlnl7ZXUicGn/Press%2FAbout%2F404?node-id=2051%3A11145&t=cUpJazhHh3xTYrS1-4
// Mobile: https://www.figma.com/file/XrlDM2ZdWXmlnl7ZXUicGn/Press%2FAbout%2F404?node-id=2051%3A11299&t=cUpJazhHh3xTYrS1-4
export default function OurMission() {
  const isMobile = useIsMobileSizedScreen();

  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <div>
          <Image alt="" className={styles.img} loading="lazy" src={isMobile ? missionMobileImg : missionImg} />
        </div>
        <div className={styles.mission}>
          <div>
            <Typography color="inverse" component="h2" variant="heading500" className={styles.header}>
              <FormattedMessage defaultMessage="Our mission" />
            </Typography>
            <Typography className={styles.text} color="inverse" component="div" variant="paragraph300">
              <FormattedMessage defaultMessage="AllTrails was founded on the idea that we’re all made better by spending time in nature. Each day, we strive to connect more people to the outdoors." />
            </Typography>
            <Button
              linkInfo={{ href: '/about' }}
              testId="learn-more"
              text={<FormattedMessage defaultMessage="Learn more about us" />}
              variant="elevated"
            />
          </div>
        </div>
      </div>
    </div>
  );
}
